import React from "react";
import MinimalPublicPage from "./MinimalPublicPage";

export default function FaqPage() {
  return (
    <MinimalPublicPage
      eyebrow="FAQ"
      title="The short version."
      description="The most common questions about joining Ouro, verification, Steam sign-in, and pricing."
      points={[
        {
          title: "Is Steam sign-in safe?",
          body: "Yes. Ouro uses read-only Steam OpenID and never asks for trade, inventory, or market permissions.",
        },
        {
          title: "Can I start for free?",
          body: "Yes. The free tier exists so players can join and understand the platform before upgrading.",
        },
        {
          title: "Is ID verification required?",
          body: "No. A Steam account is all you need to join, and every account goes through human review. An optional ID check through didit.me adds reputation if you choose it.",
        },
      ]}
      secondaryLabel="Contact"
      secondaryTo="/contact"
    />
  );
}
